import { useLocation } from 'react-router-dom'
import { readStepUpOutcome } from '@/lib/step-up'

/**
 * KAN-857 U8 — after a refused step-up the callback returns to
 * `<page>?stepup=failed&reason=<closed label>`. Show a fixed message for the
 * label; the raw query value is never rendered.
 */
export function StepUpReturnNotice() {
  const { search } = useLocation()
  const outcome = readStepUpOutcome(search)
  if (!outcome.failed) return null
  return (
    <div role="alert" className="rounded-md border border-destructive/40 bg-destructive/5 p-3 text-sm">
      Confirmation did not complete. {outcome.message}
    </div>
  )
}
